import React, { memo, useCallback } from 'react';
import { CobuCard, CobuStack, CobuText, CobuImage, CobuView } from '@cobu/ui';
import { Notification } from '@cobu/types';
import { useRelativeTime } from '../../hooks/useRelativeTime';
import { translateNotification } from '../../utils/notificationI18n';
// import Logger from '../../services/Logger';

export interface NotificationItemProps {
  notification: Notification;
  onPress: (notification: Notification) => void;
}

// Minimal HTML renderer for notifications - supports only <strong> tags
function renderHTMLContent(htmlString: string | undefined) {
  if (!htmlString) return htmlString as any;
  const parts = htmlString.split(/(<strong>.*?<\/strong>)/s);
  return parts.map((part, index) => {
    if (part.startsWith('<strong>') && part.endsWith('</strong>')) {
      const text = part.replace(/<\/?strong>/g, '');
      return (
        <CobuText key={index} fontWeight="bold" fontSize="$1">
          {text}
        </CobuText>
      );
    }
    return <React.Fragment key={index}>{part}</React.Fragment>;
  });
}

function NotificationItemComponent({ notification, onPress }: NotificationItemProps) {
  // Logger.log('notification', notification);
  const timeAgo = useRelativeTime(notification.createdAt);

  const iconSource = notification.icon?.length > 0 ? { uri: notification.icon } : undefined;

  const handlePress = useCallback(() => onPress(notification), [onPress, notification]);

  return (
    <CobuView onPress={handlePress}>
      <CobuCard
        bg={notification.isRead ? '$white' : '$lightBlueGray'}
        bw={0}
        br={0}
        p="$4"
        m={0}
        my={1}
        layout="vertical"
        gap="$2"
        f={1}
      >
        <CobuStack f={1} layout="horizontal" jc="space-between" ai="flex-start">
          <CobuImage
            style={{ width: 40, height: 40, borderRadius: 20 }}
            source={iconSource}
          />
          <CobuStack f={1} mr="$2" ml="$3">
            <CobuText fos="$2" col="$black">
              {renderHTMLContent(
                translateNotification(
                  notification.notificationType === 'af44ffbd-4fc1-4ebc-823d-f54cc9579ba0 '
                    ? notification.content
                    : (notification.contentHTML || notification.content)
                )
              )}
            </CobuText>
            <CobuText fos="$1" color="$cobuDarkBlue75">{timeAgo}</CobuText>
          </CobuStack>
        </CobuStack>
      </CobuCard>
    </CobuView>
  );
}

export const NotificationItem = memo(NotificationItemComponent); 